<template>
  <b-modal
    id="unit-details-modal"
    :visible="value"
    @hide="$emit('input', false)"
    hide-footer
    size="xl"
    :title="unit && unit.productName ? unit.productName : 'Unit Details'"
  >
    <div v-if="unit" class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <div class="card shadow-sm mb-4">
            <div class="card-body p-0">
              <b-carousel
                id="image-carousel"
                v-if="unit.documentUploads && unit.documentUploads.length > 0"
                controls
                indicators
                background="#ababab"
                :interval="4000"
                img-width="1024"
                img-height="480"
                class="rounded"
              >
                <b-carousel-slide
                  v-for="doc in unit.documentUploads"
                  :key="doc.id"
                  :img-src="`${apiBaseUrl}${doc.fileUrl}`"
                ></b-carousel-slide>
              </b-carousel>
              <div v-else class="image-placeholder d-flex align-items-center justify-content-center">
                <i class="bi bi-image-fill text-muted" title="No image available"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <h1 class="product-title">{{ unit.productName }}</h1>
              <p class="text-muted lead mb-2">Unit ID: {{ unit.id }}</p>
              <p class="badge" :class="unit.assigned ? 'bg-success' : 'bg-warning text-dark'">
                {{ unit.assigned ? 'Assigned' : 'Unassigned' }}
              </p>
              
              <hr class="my-3">
              
              <div class="details-section">
                <h6>Unit Specifications</h6>
                <div class="row mb-2">
                  <div class="col-5 text-muted">Serial Number:</div>
                  <div class="col-7 font-weight-bold">{{ unit.serialNumber || '—' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 text-muted">Category:</div>
                  <div class="col-7 font-weight-bold">{{ unit.categoryName || '—' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 text-muted">Stock Type:</div>
                  <div class="col-7 font-weight-bold">Single Unit</div>
                </div>
              </div>
              
              <hr class="my-3">

              <div class="description-section">
                  <h6>Product Description</h6>
                  <p class="text-secondary small">{{ product && product.description || 'No description available for this product.' }}</p>
              </div>

              <div class="mt-4">
                  <b-button variant="primary" block size="lg" class="mb-2">Buy This Unit</b-button>
                  <b-button variant="outline-secondary" block>Contact Seller</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-5 text-muted">
      Loading unit details...
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'UnitDetailsModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    unit: {
      type: Object,
      default: () => null
    },
    product: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      apiBaseUrl: " "
    };
  }
};
</script>

<style scoped>
/* All styles from the previous response are needed here to style the modal content */
.product-title {
  font-weight: 600;
}

.image-placeholder {
  width: 100%;
  height: 480px;
  background-color: #f8f9fa;
  font-size: 5rem;
  color: #dee2e6;
  border-radius: 0.25rem;
}

.card-body h6 {
  font-weight: 600;
  color: #343a40;
}
</style>